import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle,  Grid,  LinearProgress,  MenuItem,  Paper, Select, Snackbar, SnackbarCloseReason} from '@mui/material';
import { useState } from 'react';
import { RelatorioService } from '../../../shared/services/api/rh/Relatorios/RelatoriosService';
import aniversariantes from './Aniversariantes';
           
export const Aniversariante: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);         
  const [mes, setMes] = useState('Janeiro');   
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
            
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };          

  const handleSave = () => {      
    RelatorioService               
      .RelatorioAniversariantes(mes)   
      .then((result) => {           
        setIsLoading(false);              
        if (result instanceof Error) {                
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);                 
        }else {     
          if(result.length > 0){     
            aniversariantes(result, mes);     
          }else{
            setTms('error');
            setMsg('Não a Registros');
            setOpenmsg(true);  
          }                     
        }                    
      });                                   
  };            

  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box  display="flex" alignItems="center" alignSelf='center' alignContent='center'></Box>
      <Box   width='auto' alignItems="auto"  component={Paper} height="auto" margin={1} 
        alignContent='center'>       
        <DialogTitle>Aniversariantes do Mes</DialogTitle>
        <DialogContent  dividers sx={{width:300}}>    
          {isLoading && (           
            <Grid item>  
              <LinearProgress variant='indeterminate' />  
            </Grid>                      
          )}   
          <Grid container   item direction="row">
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>    
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>        
                <Select         
                  fullWidth
                  size='small'
                  value={mes}
                  onChange={(event) => setMes(event.target.value)}
                >   
                  <MenuItem value={'Janeiro'}>Janeiro</MenuItem>    
                  <MenuItem value={'Fevereiro'}>Fevereiro</MenuItem>
                  <MenuItem value={'Março'}>Março</MenuItem>
                  <MenuItem value={'Abril'}>Abril</MenuItem>
                  <MenuItem value={'Maio'}>Maio</MenuItem>
                  <MenuItem value={'Junho'}>Junho</MenuItem>
                  <MenuItem value={'Julho'}>Julho</MenuItem>    
                  <MenuItem value={'Agosto'}>Agosto</MenuItem>
                  <MenuItem value={'Setembro'}>Setembro</MenuItem>
                  <MenuItem value={'Outubro'}>Outubro</MenuItem>
                  <MenuItem value={'Novembro'}>Novembro</MenuItem>
                  <MenuItem value={'Dezembro'}>Dezembro</MenuItem>
                </Select>           
              </Grid>                     
            </Grid>              
          </Grid>            
        </DialogContent>                 
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   